import { render, staticRenderFns } from "./DataColumns.vue?vue&type=template&id=a14c9636"
import script from "./DataColumns.vue?vue&type=script&lang=js"
export * from "./DataColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports